import { render, staticRenderFns } from "./CompensationCommitment.vue?vue&type=template&id=527fbc32&scoped=true"
import script from "./CompensationCommitment.vue?vue&type=script&lang=js"
export * from "./CompensationCommitment.vue?vue&type=script&lang=js"
import style0 from "./CompensationCommitment.vue?vue&type=style&index=0&id=527fbc32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527fbc32",
  null
  
)

export default component.exports